import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
// import { ToastrManager } from "ng6-toastr-notifications";
// import { ToastrModule } from "ngx-toastr";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { MainService } from "../../../../service/main.service";
// import { CommonDataService } from "../../../common _services/common-data.service";
import { MainService as mainServiceMD } from "../../../../service/main.service";
import Swal from "sweetalert2";
import {SpinnerService} from '../../../../../shared/spinner.service'
declare var $: any;
import {session} from '../../../../../../environments/environment.session'
import { UtilityService } from "../../../service/utility.service";
import { Utf8EncodingService } from "src/app/md/service/utf8-encoding.service";
@Component({
  selector: 'app-utility-role-authorisation',
  templateUrl: './utility-role-authorisation.component.html',
  styleUrls: ['./utility-role-authorisation.component.css']
})
export class UtilityRoleAuthorisationComponent {

  role_flage:any = true;
  maprole_flage :any= false;
  displayedColumns: string[] = ["user_id", "name", "role_desc", "delete"];
  email:any;
  password:any;
  confirm_pass:any;
  users :any= [];
  datasource:any;
  user_id:any;
  index:any;
  Obj :any= {};
  FirstName:any;
  LastName:any;
  User_Email:any;
  b_acct_id:any;
  erpUser:any;
  account:any;
  roles:any = [];
  roleObj :any= {};


  constructor(
    private tspinner:SpinnerService,
    // public commonDataService: CommonDataService,
    private spinner: NgxSpinnerService,
    public toastr:ToastrService ,
    public mainService: MainService,
    private mainServiceMD: mainServiceMD,
    private utilityService:UtilityService,
    private utf8EncodingService:Utf8EncodingService,
  ) {}

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;

  module_cd = this.utilityService?.configObj?.module_cd;
  logObj = { component: this.module_cd+'-DATA-ASSIGNMENT' }

  async ngOnInit() {

    this.module_cd = this.utilityService?.configObj?.module_cd;
        if(!this.module_cd){
        Swal.fire('INFO','FACING ISSUE WHILE NAVIGATING','info')
          window.history.back()
          return;
        }
        
    this.tspinner.show('','')
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    this.b_acct_id = this.erpUser.b_acct_id;
    await this.getAccountUserInfo();
    await this.getAllRoles();
    await this.getAllCurrentUserList();
    this.tspinner.hide()
    // await this.getCurrentRole();
    console.log(this.mainService.allLableShowObj,
      this.mainService.language_cd+'EMB-USERS1',
      this.mainService.allLableShowObj[this.mainService.language_cd+'EMB-USERS1']);
    
  }


  async maprole() {
    this.role_flage = false;
    this.maprole_flage = true;
  }

  current_role = [];
  async getCurrentRole() {
    this.spinner.show();
    let obj :any =  {} ;
    obj["b_acct_id"] = this.b_acct_id;
    console.log(obj);
    var resp = await this.mainServiceMD.getCurrentMdRole(JSON.stringify(obj));
    console.log(resp);
    if (resp["error"] == false) {
      this.spinner.hide();
      this.current_role = resp["data"];
    } else {
      this.spinner.hide();
      Swal.fire("Error", "..Error while getting  roles", "error");
    }
  }

  single_users_role :any= [];
  selected_row:any = {};
  modalOpen(data:any) {
    this.selected_row = {};
    this.selected_row = Object.assign({}, data);
    this.single_users_role = [];
    let dummy :any= [];
    for (let i = 0; i < this.allUsers.length; i++) {
      if (data["user_id"] == this.allUsers[i]["user_id"]) {
        dummy.push(this.allUsers[i]);
      }
    }
    for (let i = 0; i < dummy.length; i++) {
      for (let j = 0; j < this.current_role.length; j++)
        if (dummy[i]["role_cd"] == this.current_role[j]["role_cd"]) {
          dummy[i]["role_desc"] = this.current_role[j]["role_desc"];
        }
    }
    this.single_users_role = dummy;
    $("#myModal1").modal("show");
  }



  async delete(element:any) {
    console.log(element);
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!",
    }).then((result) => {
      if (result.value) {
        this.finaldelete(element);
      }
    });
  }


  async finaldelete(element:any) {
    let obj :any =  {} ;
    obj = Object.assign({}, element);
    obj["b_acct_id"] = this.b_acct_id;
    this.spinner.show();
    var resp = await this.mainServiceMD.deleteUser_MD(obj);
    console.log(resp);
    if (resp["error"] == false) {
      this.spinner.hide();
      await this.getAllCurrentUserList();
      await this.modalOpen(this.selected_row);
      Swal.fire("Success", "Deleted Successfully", "success");
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp["data"], "error");
    }
  }

  allUsers:any = [];
  async getAllCurrentUserList() {
    let obj :any =   new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["module_cd"] = this.module_cd
    var resp = await this.mainServiceMD.getCurrentMdUser(JSON.stringify(obj));
    console.log(resp);
    if (resp["error"] == false) {
      this.allUsers = resp["data"];
      var emp_id:any = new Object();
      for (let i = 0; i < resp["data"].length; i++) {
        for (let j = 0; j < this.allRole.length; j++) {
          if (this.allRole[j]["role_cd"] == resp["data"][i]["role_cd"]) {
            if (emp_id[resp["data"][i]["user_id"]] == undefined) {
              resp["data"][i]["role_name"] = this.allRole[j]["role_name"];
              emp_id[resp["data"][i]["user_id"]] = resp["data"][i];
            } else {
              emp_id[resp["data"][i]["user_id"]]["role_name"] =
                emp_id[resp["data"][i]["user_id"]]["role_name"] +
                " , " +
                this.allRole[j]["role_name"];
            }
          }
        }
      }
      console.log(emp_id);
      var data = Object.values(emp_id);
      console.log(data);
      this.datasource = new MatTableDataSource(data);
      this.datasource.paginator = this.paginator;
      this.datasource.sort = this.sort;
    }
  }

  userObj :any= {};
  async getAccountUserInfo() {
    let obj :any =   new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["module_cd"] =this.module_cd
    console.log(obj);
    var resp = await this.mainServiceMD.getuserformodulerolemapping(
      JSON.stringify(obj)
    );
    if (resp["error"] == false) {
      this.users = resp.data;
      console.log(this.users);
      for (let i = 0; i < this.users.length; i++) {
        this.userObj[this.users[i]["user_id"]] = this.users[i]["emp_name"];
        this.users[i]["desc"] =
          this.users[i]["user_id"] +
          " - " +
          this.users[i]["emp_name"] +
          " - " +
          this.users[i]["emp_phone_no"];
      }
    }
  }

  roleCodeToAccess :any= {};
  allRole:any = [];
  async getAllRoles() {
    let obj :any =   new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["module_cd"] = this.module_cd
    var resp = await this.mainServiceMD.getCurrentMdRole(JSON.stringify(obj));
    console.log(resp);
    if (resp["error"] == false) {
      this.roles = [];
      this.allRole = resp.data;
      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i]["is_system_role"] == 0) {
          this.roles.push(resp.data[i]);
        }
        this.roleObj[resp.data[i]["role_cd"]] = resp.data[i]["role_name"];
      }
      console.log(this.roles);
    }
  }



  async gotolist() {
    this.role_flage = true;
    this.maprole_flage = false;
    await this.getAccountUserInfo();
    await this.getAllRoles();
    await this.getAllCurrentUserList();
    await this.getCurrentRole();
  }

  async submit() {
    let obj :any =   new Object();
    this.spinner.show();
    obj["b_acct_id"] = this.b_acct_id;
    obj["valid_upto"] = "2030-04-30";
    obj["user_id"] = this.Obj["user_id"];
    obj["role_cd"] = this.Obj["role_cd"];
    obj["create_user_id"] = this.erpUser["user_id"];
    if (obj["role_cd"] == undefined) {
      this.spinner.hide();
      Swal.fire("Error", "Plz Select Any Role....! ", "error");
      return;
    }
    if (obj["user_id"] == undefined) {
      this.spinner.hide();
      Swal.fire("Error", "Plz Select Any User....! ", "error");
      return;
    }

    var resp = await this.mainServiceMD.createMdUser(obj);
    console.log(resp);
    if (resp["error"] == false) {
      console.log(resp["data"]);
      await this.getAllCurrentUserList();
      this.role_flage = true;
      this.maprole_flage = false;
      Swal.fire("Success..", "Successfully Created", "success");
      this.spinner.hide();
    } else {
      this.spinner.hide();
      if (resp["data"] == "Duplicate entry") {
        Swal.fire("Error...", "This User Is Already Exists.", "error");
      } else {
        Swal.fire("Error", "Error While Creating", "error");
      }
    }
    this.gotolist();
  }

  applyFilter(filterValue: string) {
    this.datasource.filter = filterValue.trim().toLowerCase();
  }

  zone_flag = false;

  ChangeRole() {
    for (let i = 0; i < this.roles.length; i++) {
      if (
        this.Obj["role_cd"] == this.roles[i]["role_cd"] &&
        this.roles[i]["access"] == "ZONEWISE" &&
        this.erpUser["role_cd"] == "AA"
      ) {
        this.zone_flag = true;
        this.Obj["zone_cd"] = null;
        break;
      } else {
        this.zone_flag = false;
        this.Obj["zone_cd"] = null;
      }
    }
  }

  phone_number:any;
  search_flag :any= false;

  // async checkUserExistOrNot(phone_no:any) {
  //   var tt = false;
  //   console.log(this.phone_number);
  //   let obj :any =   new Object();
  //   obj["phone_no"] = phone_no;
  //   console.log(obj);
  //   var resp = await this.loginService.manualloginWithOtp(JSON.stringify(obj));
  //   console.log(resp);
  //   if (resp["error"] == false && resp["data"].length > 0) {
  //     for (let i = 0; i < resp.data.length; i++) {
  //       if (this.b_acct_id == resp.data[i]["b_acct_id"]) {
  //         tt = true;
  //       }
  //     }
  //   }

  //   console.log(tt);
  //   return tt;
  // }

  update_user_info_Obj:any = {};
  open_update(element:any) {
    this.update_user_info_Obj = {};
    this.update_user_info_Obj["user_id"] = element["user_id"];
    this.update_user_info_Obj["old_phone_no"] = element["phone_no"];
    this.update_user_info_Obj["old_email"] = element["email"];
    this.update_user_info_Obj["old_name"] = element["name"];
    this.update_user_info_Obj["phone_no"] = element["phone_no"];
    this.update_user_info_Obj["email"] = element["email"];
    this.update_user_info_Obj["name"] = element["name"];
    $("#update_user_info").modal("show");
  }
}


